import { Home_context } from '../../context/home_context';
import Header__descriptions from './description';
import Header_table_two from './header_table_two';
import Header_table_one from './headers_table_one';
import { useContext } from 'react';

export default function Headers() {
  const { report_data_state } = useContext(Home_context);
  return (
    <div>
      <p className="text-center main_heading">
        {/* {report_data_state?.report_data['rm_code']}
        {' - '} */}
        {report_data_state?.report_data['rm_name']}
      </p>
      {/* <p className="text-[18px] text-center page_pera_color">
        ({report_data_state?.report_data['rm_name_en']})
      </p> */}
      {/* <p className="text-[12px] pb-2  text-center page_pera_color">
          Updated on : [06/06/2024]
        </p> */}
      <br />
      <hr />

      <div>
        <div className='between_header_padding'>
          <p className="page_headers  font-semibold text-start pt-2 header_color">
            DESCRIPTIVE SYNOPSIS
          </p>
          <Header_table_one />
        </div>
        {/* <div className='between_header_padding'>
          <p className="page_headers text-start font-semibold header_color ">
            RM STATUS HISTORY :{' '}
          </p>
          <Header_table_two />
        </div> */}
        <div className='between_header_padding'>
          <p className="page_headers text-start font-semibold header_color ">
            RAW MATERIAL DESCRIPTION {' '}
          </p>
          <Header__descriptions />
        </div>
      </div>
    </div>
  );
}

// rm_code;
// chemical_category_en;
// chemical_category_lg;
// currency;
// disposal_en;
// disposal_lg;
// distributor;
// formulation_conditions_en;
// formulation_conditions_lg;
// ghs_risk_codes;
// incompatibilities_en;
// incompatibilities_lg;
// internal_status;
// internal_supplier_code;
// lead_time_in_days;
// manufacturer;
// max_percentage_use;
// min_percentage_use;
// no_animal_testing;
// notes_en;
// notes_lg;
// objectivation_tests_notes_en;
// objectivation_tests_notes_lg;
// origin_details_en;
// origin_details_lg;
// patents_en;
// patents_lg;
// presentation_en;
// presentation_lg;
// price;
// product_type;
// properties;
// regulatory_notes_en;
// regulatory_notes_lg;
// risk_comments_en;
// risk_comments_lg;
// rm_name;
// rm_name_en;
// shelf_life;
// storage_conditions_en;
// storage_conditions_lg;
// tolerance_tests_notes_en;
// tolerance_tests_notes_lg;
// warnings;
